// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","logoImage":"Header_logoImage__OY9g1","burger":"Header_burger__fT6rl"};